import { visuallyHiddenCss } from '@chegg-ui/theme'
import styled from 'styled-components'

export const HiddenLabel = styled.span`
  ${visuallyHiddenCss};
`
